import { Sun, Monitor, Moon } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useTheme } from '@/contexts/ThemeContext';

// Translated at render time (module-scope constants run before the bundles load)
const options = [
  { value: 'light' as const, Icon: Sun, labelKey: 'web:themeToggle.light' },
  { value: 'system' as const, Icon: Monitor, labelKey: 'web:themeToggle.system' },
  { value: 'dark' as const, Icon: Moon, labelKey: 'web:themeToggle.dark' },
];

export function ThemeToggle() {
  const { t } = useTranslation();
  const { theme, setTheme } = useTheme();

  return (
    <div className="flex items-center rounded-lg bg-surface-tertiary p-1">
      {options.map(({ value, Icon, labelKey }) => (
        <button
          key={value}
          onClick={() => setTheme(value)}
          title={t(labelKey)}
          className={`flex items-center justify-center rounded-md p-1.5 transition-colors ${
            theme === value
              ? 'bg-surface-primary text-text-primary shadow-sm'
              : 'text-text-tertiary hover:text-text-secondary'
          }`}
        >
          <Icon className="h-4 w-4" />
        </button>
      ))}
    </div>
  );
}
